import { useEffect, useState } from "react";

const KEY = "ozalp_cerez";

function uygula(izin) {
  // izin verilmeden analytics YÜKLENMEZ / capture edilmez
  try {
    if (izin?.analitik) {
      window.posthog?.opt_in_capturing?.();
    } else {
      window.posthog?.opt_out_capturing?.();
    }
  } catch { /* posthog yoksa sorun değil */ }
}

export function CookieConsent() {
  const [durum, setDurum] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
  });
  const [detay, setDetay] = useState(false);
  const [analitik, setAnalitik] = useState(false);

  useEffect(() => { uygula(durum || { analitik: false }); }, [durum]);

  const kaydet = (izin) => {
    localStorage.setItem(KEY, JSON.stringify(izin));
    setDurum(izin);
  };

  if (durum) return null;
  return (
    <div className="cerez-band" data-testid="cerez-band" role="dialog" aria-label="Çerez tercihleri">
      <div>
        <p>Deneyiminizi iyileştirmek için çerezler kullanıyoruz. Analitik çerezler yalnızca onayınızla çalışır; onaylamazsanız hiçbir analitik betiği yüklenmez.</p>
        {detay && (
          <div className="cerez-detay">
            <label><input type="checkbox" checked disabled /> Zorunlu çerezler (her zaman açık)</label>
            <label><input type="checkbox" checked={analitik} onChange={(e) => setAnalitik(e.target.checked)} data-testid="cerez-analitik" /> Analitik çerezler</label>
          </div>
        )}
      </div>
      <div className="butonlar">
        {!detay && <button className="reddet" onClick={() => setDetay(true)} data-testid="cerez-ayarla">Ayarla</button>}
        <button className="reddet" onClick={() => kaydet({ zorunlu: true, analitik: false })} data-testid="cerez-reddet">Reddet</button>
        <button className="kabul" onClick={() => kaydet({ zorunlu: true, analitik: detay ? analitik : true })} data-testid="cerez-kabul">{detay ? "Seçimi kaydet" : "Kabul et"}</button>
      </div>
    </div>
  );
}
